import React from 'react';
import styled from 'styled-components';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import palette from '../../lib/styles/palette';
import SettingCard, { SettingInfoBox, SettingInfoLabel, SettingInfoValue, CardFooter, SaveButton } from './SettingCard';

const RadioFieldBox = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background: #f8f9fb;
    border: 1px solid #e0e4ea;
    border-radius: 12px;
    transition: border-color 0.15s ease;

    .MuiFormControlLabel-label {
        font-size: 0.95rem;
        color: #555;
    }

    .MuiRadio-colorPrimary.Mui-checked {
        color: ${palette.webCyan[5]};
    }

    .MuiRadio-colorPrimary.Mui-checked + .MuiFormControlLabel-label,
    .Mui-checked ~ .MuiFormControlLabel-label {
        color: #2c3e50;
        font-weight: 600;
    }
`;

const AdminClubTypeInfo = ({
    selectClubInfo,
    setClubType,
    setChangeClubTypeInfo
}) => {

    const onChangeClubType = (e) => {
        setClubType(parseInt(e.target.value))
    }

  return selectClubInfo ? (
    <SettingCard title="클럽 유형 설정">
        <SettingInfoBox>
            <SettingInfoLabel>클럽 유형</SettingInfoLabel>
            <SettingInfoValue>
                <RadioFieldBox>
                    <RadioGroup
                        aria-label="clubType"
                        name="clubType"
                        value={selectClubInfo.clubStyle != null ? selectClubInfo.clubStyle : 0}
                        onChange={onChangeClubType}
                        row={true}
                    >
                        <FormControlLabel
                            value={0}
                            control={<Radio color="primary" />}
                            label="헬스장"
                        />
                        <FormControlLabel
                            value={1}
                            control={<Radio color="primary" />}
                            label="비헬스장"
                        />
                    </RadioGroup>
                </RadioFieldBox>
            </SettingInfoValue>
        </SettingInfoBox>
        <CardFooter>
            <SaveButton active={selectClubInfo.isClubTypeEdit} onClick={() => setChangeClubTypeInfo()}>
                수정하기
            </SaveButton>
        </CardFooter>
    </SettingCard>
  ) : null;
};

export default React.memo(AdminClubTypeInfo);
